import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { UserIdentityService } from 'projects/apna-lib/src/lib/services/user-identity.service';

interface ProfileCompletion {
  total: number;
  filled: number;
  percentage: number;
  details: {
    [key: string]: {
      required: string[];
      filled: string[];
      missing: string[];
    };
  };
}

interface AcademicCompletion {
  total: number;
  filled: number;
  percentage: number;
  details: {
    [key: string]: {
      required: string[];
      filled: string[];
      missing: string[];
    };
  };
}

interface TestScoreCompletion {
  hasAnyTest: boolean;
  percentage: number;
  availableTests: string[];
}


@Component({
  selector: 'app-student-content-forms',
  templateUrl: './student-content-forms.component.html',
  styleUrls: ['./student-content-forms.component.scss']
})
export class StudentContentFormsComponent implements OnInit {

  @Input() isMobileMenuOpen = false;
  @Output() closeMobileMenu = new EventEmitter<void>();

  sectionCompletionData: any;
  active = 1;
  studentData: any;
  studentId: any;
  applicantData: any;
  applicantId: any;
  companyName: any;
  // shortlistingUrl: string;
  profileCompletion: ProfileCompletion;
  academicCompletion: AcademicCompletion;
  testScoreCompletion: TestScoreCompletion;
  userDetails: any;
  documentData: any;
  documentCompletion: any;
  overallCompletion: number = 0;
  isDocumentLocked: boolean = true;
  isApplicationSectionLocked: boolean = true;
  workExperienceExist: boolean = false;
  applicationData: any;
  error: string;
  @ViewChild('nav') navRef: NgbNav;
  puid: any;

  remainingProfileSection: boolean = false;
  remainingAcademicSection: boolean = false;
  remainingTestScoreSection: boolean = false;


  ngOnInit(): void {
    this.puid = this.activateRoute.snapshot.paramMap.get('puid');
    console.info('Parent component initialized');
    this.getStudentId();
  }

  constructor(
    private apiHelper: ApiHelperService,
    private activateRoute: ActivatedRoute,
    private route: Router,
    private userIdentity: UserIdentityService
  ) {
    this.userIdentity.getBucketAcccesToken()
  }


  onCloseMobileMenu(): void {
    this.closeMobileMenu.emit();
  }

  private getStudentId() {
    const uid = localStorage.getItem('uid');

    if (!uid) {
      console.error('No UID found in localStorage');

      this.route.navigate(['/login']);
      return;
    }

    // Use existing getDataWithShortlistingUrl method to get student ID
    this.apiHelper.getDataWithShortlistingUrl(`user/student-id/${uid}`)
      .then((response: any) => {
        if (response) {
          this.studentId = response.data.studentId;
          this.getStudentAdmissionInfo(this.studentId);
        } else {
          console.error('Failed to get student ID');
          this.studentData = null;
        }
      })
      .catch((error: any) => {
        console.error('Error fetching student ID:', error);
        this.studentData = null;
      });
  }

  getStudentAdmissionInfo(id: any) {
    this.apiHelper.getDataWithShortlistingUrl(`university-students/by-student-id/${id}`)
      .then((res: any) => {
        if (res && Object.keys(res).length > 0) {
          this.studentData = res;
          console.info('Student data fetched:', this.studentData);
          this.applicantId = res?._id;
          this.getWishlistedUniversities()
          setTimeout(() => {
            this.profileCompletion = this.calculatePersonalProfileCompletion(res);
            this.academicCompletion = this.calculateAcademicCompletion(
              res.academicQualification || {}
            );
            this.testScoreCompletion = this.calculateTestScoreCompletion(res);

            if (this.profileCompletion?.percentage !== 100) {
              this.remainingProfileSection = true;
            }
            else {
              this.remainingProfileSection = false;
            }

            if (this.academicCompletion?.percentage !== 100) {
              this.remainingAcademicSection = true;
            }
            else {
              this.remainingAcademicSection = false;
            }

            if (this.testScoreCompletion?.percentage !== 100) {
              this.remainingTestScoreSection = true;
            }
            else {
              this.remainingTestScoreSection = false;
            }

            this.sectionCompletionData = {
              profileSection: this.remainingProfileSection,
              academicSection: this.remainingAcademicSection,
              testScoreSection: this.remainingTestScoreSection
            };
            this.calculateOverallCompletion();
            this.fetchDocumentByApplicantId(id);
          }, 1000);
        } else {
          this.studentData = null;
        }
      })
      .catch((error: any) => {
        console.error('Error fetching applicant data:', error);
        this.studentData = null;
      });
  }

  checkapplicationDocLockData(ev: any) {

  }

  getUpdateProfileData(ev: boolean) {
    if (ev) {
      this.getStudentAdmissionInfo(this.studentId)
    }
  }

  getWishlistedUniversities() {

    const query = {
      where: JSON.stringify({ _id: this.applicantId })
    };

    this.apiHelper.getDataWithShortlistingUrl("university-students/", query).then((res: any) => {
      this.applicantData = res?.data[0];
    });

  }

  fetchDocumentByApplicantId(applicantId: any) {

    if (!applicantId) {
      return;
    }

    this.apiHelper.getDataWithShortlistingUrl("documents", { applicantId }).then(
      (response: any) => {
        if (response) {
          this.documentData = response;
          this.documentCompletion = this.calculateDocumentCompletion(this.documentData, this.studentData?.academicQualification?.highestLevel, this.workExperienceExist);
        }
      },
      (err: any) => {
        console.error("Error fetching document by applicantId:", err);
      }
    );
  }

  calculatePersonalProfileCompletion(profile: any): ProfileCompletion {
    const personalInfo = profile.personalInformation || {};

    const baseFields = [
      'email',
      'firstName',
      'lastName',
      'phoneNumber',
      'dateOfBirth',
      'gender',
      'maritalStatus',
    ];

    const nestedFields = {
      mailingAddress: ['line1', 'country', 'city', 'state', 'pincode'],
      permanentAddress: ['line1', 'country', 'city', 'state', 'pincode'],
      passport: [
        'number',
        'issueDate',
        'expiryDate',
        'isssueCountry',
        'cityOfBirth',
        'countryOfBirth',
      ],
      nationality: ['country', 'citizenship', 'hasMultipleCitizenship'],
      background: [
        'immigrationApplied',
        'hasMedicalCondition',
        'visaRefused',
        'hasCriminalRecord',
      ],
      emergency: ['name', 'phone', 'email', 'relationshipWithApplicant'],
    };

    let totalFields = baseFields.length;
    let filledFields = 0;
    const details: any = {
      baseInfo: {
        required: baseFields,
        filled: [],
        missing: [],
      },
    };

    baseFields.forEach((field) => {
      if (
        personalInfo[field] !== undefined &&
        personalInfo[field] !== null &&
        personalInfo[field] !== ''
      ) {
        filledFields++;
        details.baseInfo.filled.push(field);
      } else {
        details.baseInfo.missing.push(field);
      }
    });

    // Check nested fields also from personalInformation
    for (const [section, fields] of Object.entries(nestedFields)) {
      details[section] = {
        required: fields,
        filled: [],
        missing: [],
      };

      totalFields += fields.length;

      fields.forEach((field) => {
        let value = personalInfo?.[section]?.[field];

        if (value !== undefined && value !== null && value !== '') {
          filledFields++;
          details[section].filled.push(field);
        } else {
          details[section].missing.push(field);
        }
      });
    }

    // Handle conditional fields - update these to use personalInfo
    if (personalInfo?.nationality?.hasMultipleCitizenship) {
      totalFields++;
      if (personalInfo?.nationality?.hasMultipleCitizenshipCountry) {
        filledFields++;
        details.nationality.filled.push('hasMultipleCitizenshipCountry');
      } else {
        details.nationality.missing.push('hasMultipleCitizenshipCountry');
      }
    }

    if (profile?.nationality?.isStudyingAbroad) {
      totalFields++;
      if (profile?.nationality?.isStudyingAbroadCountry) {
        filledFields++;
        details.nationality.filled.push('isStudyingAbroadCountry');
      } else {
        details.nationality.missing.push('isStudyingAbroadCountry');
      }
    }

    // Background conditional fields
    if (profile?.background?.immigrationApplied) {
      totalFields++;
      if (profile?.background?.immigrationAppliedCountry) {
        filledFields++;
        details.background.filled.push('immigrationAppliedCountry');
      } else {
        details.background.missing.push('immigrationAppliedCountry');
      }
    }

    if (profile?.background?.hasMedicalCondition) {
      totalFields++;
      if (profile?.background?.medicalDetails) {
        filledFields++;
        details.background.filled.push('medicalDetails');
      } else {
        details.background.missing.push('medicalDetails');
      }
    }

    if (profile?.background?.visaRefused) {
      totalFields += 2; // For both country and type
      if (profile?.background?.visaRefusalCountry) {
        filledFields++;
        details.background.filled.push('visaRefusalCountry');
      } else {
        details.background.missing.push('visaRefusalCountry');
      }
      if (profile?.background?.visaRefusalType) {
        filledFields++;
        details.background.filled.push('visaRefusalType');
      } else {
        details.background.missing.push('visaRefusalType');
      }
    }

    if (profile?.background?.hasCriminalRecord) {
      totalFields++;
      if (profile?.background?.criminalRecordDetails) {
        filledFields++;
        details.background.filled.push('criminalRecordDetails');
      } else {
        details.background.missing.push('criminalRecordDetails');
      }
    }

    const result = {
      total: totalFields,
      filled: filledFields,
      percentage: Math.round((filledFields / totalFields) * 100),
      details,
    };

    return result;
  }

  calculateAcademicCompletion(academicInfo: any): ProfileCompletion {
    const baseFields = ['countryOfEducation', 'highestLevel'];
    const nestedFields = {
      grade10: [
        'country',
        'state',
        'level',
        'boardName',
        'degreeType',
        'schoolName',
        'city',
        'schoolScoreSystem',
        'schoolScore',
        'language',
        'startDate',
        'endDate',
      ],
      highSchoolMarks: [
        'country',
        'state',
        'level',
        'boardName',
        'degreeType',
        'highSchoolName',
        'city',
        'highSchoolScoreSystem',
        'highSchoolScore',
        'language',
        'startDate',
        'endDate',
      ],
      undergraduateMarks: [
        'country',
        'state',
        'level',
        'undergradCollegeName',
        'degreeType',
        'city',
        'scoreSystem',
        'score',
        'language',
        'degreeBacklogs',
        'startDate',
        'endDate',
      ],
      postgraduateMarks: [
        'country',
        'state',
        'level',
        'postgradCollegeName',
        'degreeType',
        'city',
        'scoreSystem',
        'score',
        'language',
        'degreeBacklogs',
        'startDate',
        'endDate',
      ],
      phdMarks: [
        'country',
        'state',
        'level',
        'postgradCollegeName',
        'degreeType',
        'city',
        'scoreSystem',
        'score',
        'language',
        'degreeBacklogs',
        'startDate',
        'endDate',
      ],
    };

    let totalFields = baseFields.length;
    let filledFields = 0;
    const details: any = {
      baseInfo: {
        required: baseFields,
        filled: [],
        missing: [],
      },
    };

    baseFields.forEach((field) => {
      if (
        academicInfo[field] !== undefined &&
        academicInfo[field] !== null &&
        academicInfo[field] !== ''
      ) {
        filledFields++;
        details.baseInfo.filled.push(field);
      } else {
        details.baseInfo.missing.push(field);
      }
    });

    const applicableLevels = [];
    const highestLevel = academicInfo.highestLevel;

    if (highestLevel) {
      applicableLevels.push('grade10');

      if (['highSchool', 'undergraduate', 'postgraduate', 'phd'].includes(highestLevel)) {
        applicableLevels.push('highSchoolMarks');
      }

      if (['undergraduate', 'postgraduate', 'phd'].includes(highestLevel)) {
        applicableLevels.push('undergraduateMarks');
      }

      if (['postgraduate', 'phd'].includes(highestLevel)) {
        applicableLevels.push('postgraduateMarks');
      }
      if (highestLevel === 'phd') {
        applicableLevels.push('phdMarks');
      }
    }

    for (const [section, fields] of Object.entries(nestedFields)) {
      details[section] = {
        required: fields,
        filled: [],
        missing: [],
      };

      const shouldCount = applicableLevels.includes(section);

      if (shouldCount) {
        totalFields += fields.length;

        if (!academicInfo?.[section]) {
          details[section].missing = [...fields];
        } else {
          fields.forEach((field) => {
            const value = academicInfo[section][field];
            if (value !== undefined && value !== null && value !== '') {
              filledFields++;
              details[section].filled.push(field);
            } else {
              details[section].missing.push(field);
            }
          });
        }
      }
    }
    const result = {
      total: totalFields,
      filled: filledFields,
      percentage: Math.round((filledFields / totalFields) * 100),
      details,
    };
    return result;
  }

  calculateTestScoreCompletion(profile: any): TestScoreCompletion {
    const testScores = profile?.testScores || {};
    const possibleTests = [
      'gre',
      'ielts',
      'toefl',
      'act',
      'det',
      'pte',
      'gmat',
      'sat',
    ];

    // Get list of available tests
    const availableTests = possibleTests.filter(
      (test) => testScores[test] && Object.keys(testScores[test]).length > 0
    );
    const hasAnyTest = availableTests.length > 0;
    const result = {
      hasAnyTest,
      percentage: hasAnyTest ? 100 : 0,
      availableTests,
    };
    return result;
  }

  calculateOverallCompletion(): void {
    if (
      !this.profileCompletion ||
      !this.academicCompletion ||
      !this.testScoreCompletion
    ) {
      this.overallCompletion = 0;
      return;
    }

    this.overallCompletion = Math.round(
      (this.profileCompletion.percentage +
        this.academicCompletion.percentage +
        this.testScoreCompletion.percentage) /
      3
    );

    if (this.overallCompletion === 100) {
      this.isDocumentLocked = false;
    }
    else {
      this.isDocumentLocked = true;
      this.isApplicationSectionLocked = true;
    }
  }


  getDocumentUpdatedData(ev: any) {
    if (ev) {
      this.getStudentAdmissionInfo(this.studentId);
      this.fetchDocumentByApplicantId(this.applicantId);
    }
  }



  calculateDocumentCompletion(documentData: any, highestLevel?: string, workExperienceExist?: boolean): number {

    if (!documentData || !documentData.generalDocs) {
      return 0;
    }

    let requiredDocs = [
      "passportCopy",
      "cv",
      "letterOfRecommendationFromUniversity",
      "recommenderDetails",
      "statementOfPurpose"
    ];

    if (highestLevel === "grade10") {
      requiredDocs.push("tenthMarksheet");
    }
    if (highestLevel === "grade12") {
      requiredDocs.push("tenthMarksheet", "twelthMarksheet");
    }
    if (highestLevel === "undergraduate") {
      requiredDocs.push("tenthMarksheet", "twelthMarksheet", "transcript", "undergraduateMarksheet");
    }
    if (highestLevel === "postgraduate") {
      requiredDocs.push("tenthMarksheet", "twelthMarksheet", "transcript", "undergraduateMarksheet", "postgraduateMarksheet");
    }
    if (highestLevel === "phd") {
      requiredDocs.push("tenthMarksheet", "twelthMarksheet", "transcript", "undergraduateMarksheet", "postgraduateMarksheet", "phdMarksheet");
    }

    if (workExperienceExist) {
      requiredDocs.push("letterOfRecommendationFromWorkExp");
    }

    requiredDocs = [...new Set(requiredDocs)];

    let totalRequired = requiredDocs.length;
    let uploadedCount = 0;

    requiredDocs.forEach((doc) => {
      if (documentData.generalDocs[doc] && documentData.generalDocs[doc].filePath.length > 0) {
        uploadedCount++;
      }
    });

    let documentCompletePercentage = Math.round((uploadedCount / totalRequired) * 100);

    if (documentCompletePercentage === 100 && this.overallCompletion === 100) {
      this.isApplicationSectionLocked = false;
    } else {
      this.isApplicationSectionLocked = true;
    }

    return documentCompletePercentage;
  }
  handleTabChange(tabId: number) {

    if (tabId === 5) {
      this.route.navigate(['/results']);
      setTimeout(() => {
        this.active = this.active;
        this.navRef?.select(this.active);
      }, 0);
      return false;
    } else if (tabId === 6) {
      this.route.navigate(['/wishlist']);
      setTimeout(() => {
        this.active = this.active;
        this.navRef?.select(this.active);
      }, 0);
      return false;
    }
    return true;
  }

}
